import React, { useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { Helmet } from "react-helmet";
import { faq } from "../../Data/Faq";
import classes from "./FaqStyles.module.css";

function Faq() {
  const [indexValue, setIndexValue] = useState(null);

  const onToggleClickhandler = (index) => {
    setIndexValue((current) => (current === index ? null : index));
  };

  // FAQPage structured data — a direct SEO win since Google can render
  // these question/answer pairs straight into search results.
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map(({ title, description }) => ({
      "@type": "Question",
      name: title,
      acceptedAnswer: {
        "@type": "Answer",
        text: description,
      },
    })),
  };

  return (
    <main className={classes.main}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <div className={classes.left_section}>
        <p className={classes.eyebrow}>FAQ</p>
        <h2>Frequently Asked Questions</h2>

        <p>
          Quick answers to what people ask us most about bills, rides, and
          your Sprinterwave account. Can't find what you're looking for?
          Reach out and we'll help directly.
        </p>

        {faq.map(({ description, title }, index) => {
          const isOpen = indexValue === index;
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;

          return (
            <div
              className={classes.list_wrapper}
              data-open={isOpen}
              key={title ?? index}
            >
              <button
                type="button"
                id={buttonId}
                className={classes.title_seciton}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => onToggleClickhandler(index)}
              >
                <h3>{title}</h3>
                <BsChevronDown className={classes.chevron} aria-hidden="true" />
              </button>

              <div className={classes.panelWrapper}>
                <div
                  className={classes.description_section}
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                >
                  <p>{description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className={classes.right_section}>
        <div className={classes.subscribe}>
          <h3>Still have questions?</h3>
          <p>
            Our support team is on hand for anything not covered here —
            reach out and we'll get back to you fast.
          </p>

          <a href="#contact_us" className={classes.ctaButton}>
            Contact us →
          </a>
        </div>
      </div>
    </main>
  );
}

export default Faq;